<script>
  import { FormGroup } from "carbon-components-svelte";
  import {
    DataTable,
    Button,
    Checkbox,
    NumberInput,
  } from "carbon-components-svelte";

  import { fetchWithSession } from "lib/util/fetchWithSession.js";
  import Header from "../../../../lib/components/Header.svelte";
  import { formatISOTimestamp } from "../../../../lib/util/formatfunctions";

  export let analysisid;

  let preprocessingSteps = [];
  let preprocessingHistory = [];

  async function getPreprocessingHistory() {
    const res = await fetchWithSession(
      `/api/analysis/preprocessingHistory?analysisid=` + analysisid
    );
    const text = await res.json();
    const formattedArray = text.map((item) => ({
      ...item,
      time: formatISOTimestamp(item.time),
    }));
    preprocessingHistory = formattedArray;
    if (res.ok) {
      return text;
    } else {
      throw new Error(text);
    }
  }
  
  $: getPreprocessingHistory();

  async function allPreprocessing() {
    const res = await fetchWithSession(`/api/analysis/startPreprocessing`, {
      body: JSON.stringify({
        steps: preprocessingSteps,
        analysisid: analysisid,
        recalculate: {
          min_frequency: min_frequency,
          min_length: min_length,
          min_frequency_process: min_frequency_process,
          min_length_process: min_length_process,
          min_frequency_auto: min_frequency_auto,
          min_length_auto: min_length_auto,
        },
      }),
      method: "POST",
    });
    const text = await res.json();
    getPreprocessingHistory();
    if (res.ok) {
      return text;
    } else {
      throw new Error(text);
    }
  }

  let min_frequency = 2;
  let min_length = 2;
  let min_frequency_process = 2;
  let min_length_process = 2;
  let min_frequency_auto = 4;
  let min_length_auto = 4;
</script>

<Header section="Preprocessing" breadcrumb="Summary" />

<FormGroup legendText="App Preprocessing">
  <Checkbox
    labelText="Preprocess Application Titles"
    value={"applogrules"}
    bind:group={preprocessingSteps}
  />
  <Checkbox
    labelText="Finalize Application Titles"
    value={"applogfinalize"}
    bind:group={preprocessingSteps}
  />
</FormGroup>

<FormGroup legendText="UI Preprocessing">
  <Checkbox
    labelText="Preprocess UI Elements"
    value={"uilogrules"}
    bind:group={preprocessingSteps}
  />
  <Checkbox
    labelText="Process Undefined UI Elements"
    value={"uilogclustering"}
    bind:group={preprocessingSteps}
  />
</FormGroup>

<FormGroup legendText="Finalize Preprocessing">
  <Checkbox
    labelText="Finalize UI Elements"
    value={"finalize"}
    bind:group={preprocessingSteps}
  />
  <Checkbox
    labelText="Recalculate Processes (UI Element based)"
    value={"recalculate"}
    bind:group={preprocessingSteps}
  />
  <Checkbox
    labelText="Recalculate Processes (Window Title based)"
    value={"recalculate_app"}
    bind:group={preprocessingSteps}
  />
  <Checkbox
    labelText="Annotate Process Steps"
    value={"windowTitleAnnotations"}
    bind:group={preprocessingSteps}
  />
  <Checkbox
    labelText="Activity Mapping"
    value={"activityMapping"}
    bind:group={preprocessingSteps}
  />
  <Checkbox
    labelText="Recalculate Automation"
    value={"automationcalculation"}
    bind:group={preprocessingSteps}
  />
</FormGroup>

<FormGroup legendText="Case Preprocessing">
  <Checkbox
    labelText="Process Objects"
    value={"caseidmapping"}
    bind:group={preprocessingSteps}
  />
</FormGroup>

<FormGroup legendText="Recalculate Parameters">
  <NumberInput
    label="Number of Processes"
    helperText="Minimum frequency of traces"
    bind:value={min_frequency}
  />
  <NumberInput
    label="Min Length"
    helperText="Minimum length of traces"
    bind:value={min_length}
  />
  <NumberInput
    label="Min Frequency"
    helperText="Minimum frequency of traces"
    bind:value={min_frequency_process}
  />
  <NumberInput
    label="Min Length"
    helperText="Minimum length of traces"
    bind:value={min_length_process}
  />
</FormGroup>

<FormGroup legendText="Automation Parameters">
  <NumberInput
    label="Min Frequency"
    helperText="Minimum frequency of traces"
    bind:value={min_frequency_auto}
  />
  <NumberInput
    label="Min Length"
    helperText="Minimum length of traces"
    bind:value={min_length_auto}
  />
</FormGroup>

<Button on:click={allPreprocessing} disabled={preprocessingSteps.length == 0}
  >Apply Preprocessing</Button
>

<DataTable
  rows={preprocessingHistory}
  headers={[
    { key: "time", value: "Date and Time" },
    { key: "appliedsteps", value: "Applied Steps" },
    { key: "status", value: "Status" },
  ]}
></DataTable>
